export default __webpack_public_path__ + "static/media/9cce8c4716386be4bdf4bed47955b819.898ae052.png";